<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Logi produkcyjne</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <strong>Logi produkcyjne</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight logs">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isFiltersOpen = !isFiltersOpen">
            <h5>Filtry</h5>
            <span class="ibox-toggle">
              <i :class="chevronFiltersClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isFiltersOpen">
            <div class="row">
              <div class="col-md-3 nopadding">
                <div class="form-group">
                  <label class="control-label col-sm-2">Wybierz daty</label>
                  <div class="col-sm-8">
                    <VueDatePicker
                      class="stats-daterangepicker"
                      v-model="statsRangeDate"
                      multi-calendars
                      :format="format"
                      range
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-2 nopadding">
                <div class="form-group">
                  <label class="col-sm-2 control-label">
                    Proces produkcyjny
                  </label>
                  <div class="col-sm-10">
                    <select
                      v-model="productionProcess"
                      class="form-control m-b ng-pristine"
                    >
                      <option
                        v-for="(status, key) in statuses"
                        :value="status[0]"
                        :key="key"
                      >
                        {{ status[1] }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isSummaryOpen = !isSummaryOpen">
            <h5>Podsumowanie</h5>
            <span class="ibox-toggle">
              <i :class="chevronSummaryClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isSummaryOpen">
            <div class="row">
              <div v-if="summary" class="col-sm-12 m-b-xs">
                {{ summary.sum }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title" @click="isLogsOpen = !isLogsOpen">
            <h5>Logi produkcyjne</h5>
            <span class="ibox-toggle">
              <i :class="chevronLogsClass"></i>
            </span>
          </div>
          <div class="ibox-content" v-show="isLogsOpen">
            <div class="row">
              <div class="col-sm-12 m-b-xs">
                <div class="form-group">
                  <label class="control-label col-sm-2">
                    Wpisz liczbę wierszy:
                  </label>
                  <div class="col-sm-2">
                    <input
                      class="form-control inputClass"
                      type="text"
                      v-model="rowsPerPage"
                      @change="setRowsPerPage"
                      @click="isSearch = false"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12 m-b-xs" v-if="items">
                <button @click="resetFilters" class="btn btn-primary btn-xs">
                  <i class="fa fa-refresh"></i>
                </button>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
                <EasyDataTable
                  v-model:server-options="serverOptions"
                  :server-items-length="itemsAll"
                  :headers="headers"
                  :items="items"
                  :loading="loading"
                  alternating
                  multi-sort
                  border-cell
                  @update-sort="updateSort"
                  class="table-search"
                >
                  <template #header="header">
                    <span v-if="header.text">{{ header.text }}</span>
                    <input
                      class="table-search"
                      type="text"
                      v-if="header.search"
                      v-model="searchValue[header.value]"
                      @keyup="search"
                      @click="isSearch = true"
                    />
                  </template>
                </EasyDataTable>
                <div class="pagination" v-if="itemsAll">
                  <span class="items-all">
                    Ilość rekordów: <b>{{ itemsAll }}</b>
                  </span>
                  <span>
                    Ilość na stronę:
                    <select v-model="serverOptions.rowsPerPage">
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <span>
                    <input type="number" v-model="serverOptions.page" /> -
                    {{ Math.ceil(itemsAll / serverOptions.rowsPerPage) }}
                  </span>
                  <button @click="selectPage(1)" class="btn btn-primary ml-25">
                    Pierwsza
                  </button>
                  <button
                    @click="serverOptions.page = serverOptions.page - 1"
                    :disabled="serverOptions.page === 1"
                    class="prev nl"
                  ></button>
                  <button
                    @click="serverOptions.page = serverOptions.page + 1"
                    :disabled="
                      serverOptions.page ===
                      Math.ceil(itemsAll / serverOptions.rowsPerPage)
                    "
                    class="next"
                  ></button>
                  <button
                    @click="
                      selectPage(
                        Math.ceil(itemsAll / serverOptions.rowsPerPage)
                      )
                    "
                    class="btn btn-primary"
                  >
                    Ostatnia
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, watch, ref, onMounted } from "vue";
import { useStore } from "vuex";

export default {
  name: "ProductionlogsList",
  mixins: [],
  components: {},
  props: {},

  setup() {
    const store = useStore();
    const prodlogsData = computed(() => store.getters.getProdlogsData);
    const logStatuses = computed(() => store.getters.getLogStatusesData);
    const summaryData = computed(() => store.getters.getProdLogsSummaryData);
    const chevronFiltersClass = computed(() =>
      isFiltersOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronSummaryClass = computed(() =>
      isSummaryOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    const chevronLogsClass = computed(() =>
      isLogsOpen.value ? "fa fa-chevron-up" : "fa fa-chevron-down"
    );
    let headers = [
      { text: "Nr", value: "pk" },
      { text: "Data zdarzenia", value: "created", sortable: true },
      { text: "Użytkownik", value: "name", sortable: true, search: true },
      {
        text: "Zmieniony proces",
        value: "changed_object_name",
        sortable: true,
      },
      { text: "NR Zamówienia", value: "order_id", search: true },
      {
        text: "ID pozycji zamówienia",
        value: "order_product_id",
        search: true,
      },
      { text: "Nr montażu", value: "montage_nr", search: true },
      { text: "Status przed zmianą", value: "old_values" },
      { text: "Status po zmianie", value: "new_values" },
      { text: "Data rozpoczęcia", value: "start_date" },
      { text: "Data zakończenia", value: "end_date" },
      { text: "Czas", value: "time" },
    ];
    const loading = ref(true);
    const prodProcess = ref();
    const searchValue = ref({});
    const isSearch = ref(false);
    const rowsPerPage = ref();
    const serverOptions = ref({
      page: 1,
      rowsPerPage: 25,
    });
    const statsRangeDate = ref();
    let items = ref([]);
    let itemsAll = ref(0);
    let statuses = ref([]);
    let productionProcess = ref("");
    let summary = ref("");
    let isFiltersOpen = ref(true);
    let isSummaryOpen = ref(true);
    let isLogsOpen = ref(true);
    store.dispatch("getLogStatuses");
    store.dispatch("getProdLogsSummary");

    const getProdlogs = async () => {
      loading.value = true;
      let sort;
      if (serverOptions.value.sortType === "desc") {
        sort = "-" + serverOptions.value.sortBy;
      } else {
        sort = serverOptions.value.sortBy;
      }
      await store.dispatch("getProdlogs", {
        page: serverOptions.value.page,
        itemsPerPage: serverOptions.value.rowsPerPage,
        ordering: sort,
        status: productionProcess.value,
        date: statsRangeDate.value,
        search: searchValue.value,
      });
    };

    const format = (date) => {
      let day, month, year, dayEnd, monthEnd, yearEnd;
      if (date[0]) {
        day = date[0].getDate();
        month = date[0].getMonth() + 1;
        year = date[0].getFullYear();
      }

      if (date[1]) {
        dayEnd = date[1].getDate();
        monthEnd = date[1].getMonth() + 1;
        yearEnd = date[1].getFullYear();
      }

      if (date.length > 1) {
        return `${day}/${month}/${year} - ${dayEnd}/${monthEnd}/${yearEnd}`;
      }
    };

    const search = () => {
      isSearch.value = true;
      if (searchValue.value) {
        selectPage(1);
        setTimeout(() => {
          getProdlogs();
          isSearch.value = false;
        }, 1000);
      }
    };

    const updateSort = () => {
      search.value = true;
    };

    const selectPage = (page) => {
      serverOptions.value.page = page;
    };

    const resetFilters = () => {
      searchValue.value = {};
      serverOptions.value.sortBy = "";
      getProdlogs();
    };

    const setRowsPerPage = () => {
      serverOptions.value.rowsPerPage = rowsPerPage.value;
    };

    onMounted(() => {
      if (localStorage.getItem("productionlSearchValue") !== null) {
        searchValue.value = localStorage.getItem("productionlSearchValue");
        searchValue.value = JSON.parse(searchValue.value);
      }
      getProdlogs();
    });

    watch(
      () => searchValue.value,
      function () {
        localStorage.setItem(
          "productionlSearchValue",
          JSON.stringify(searchValue.value)
        );
        getProdlogs();
      },
      { deep: true }
    );

    watch(
      () => prodlogsData.value,
      function (newValue) {
        itemsAll.value = newValue.data.count;
        items.value = [];
        newValue.data.results?.forEach((element) => {
          items.value.push(element);
        });
        loading.value = false;
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        getProdlogs();
      }
    );

    watch(
      () => productionProcess.value,
      function () {
        getProdlogs();
      }
    );

    watch(
      () => logStatuses.value,
      function (newValue) {
        statuses.value = newValue.data;
      }
    );

    watch(
      () => summaryData.value,
      function (newValue) {
        summary.value = newValue.data;
      }
    );

    watch(
      () => serverOptions.value,
      function () {
        if (!isSearch.value) {
          getProdlogs();
          isSearch.value = false;
        }
      },
      { deep: true }
    );

    return {
      headers,
      serverOptions,
      items,
      itemsAll,
      loading,
      prodProcess,
      statuses,
      productionProcess,
      statsRangeDate,
      format,
      summary,
      searchValue,
      search,
      updateSort,
      isSearch,
      rowsPerPage,
      selectPage,
      setRowsPerPage,
      resetFilters,
      isFiltersOpen,
      isSummaryOpen,
      isLogsOpen,
      chevronFiltersClass,
      chevronSummaryClass,
      chevronLogsClass,
    };
  },
  computed: {},
};
</script>

<style scoped>
.ibox-title {
  cursor: pointer;
  position: relative;
}

.ibox-toggle {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #676a6c;
}

.ibox-toggle:hover {
  color: #333;
}
</style>
